import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import MAXIMUM_CUSTOM_REWARD_CHARACTERS from "@irati/reward/constants/maximumCustomRewardName"
import Card from "@irati/ui/src/Layout/Card"
import {injectIntl, FormattedMessage, InjectIntl} from "@irati/utils/lang"
import {H4} from "@irati/ui/src/Headings"
import history from "@irati/utils/history"
import {rewardTracking} from "@irati-tracking/reward"

import {customRewardNameSchema} from "../../helpers/validation/schema"
import {Input, Button} from "./styled"

interface Props extends InjectIntl {}

interface State {
  customRewardName?: string
}

class Sidebar extends PureComponent<Props, State> {
  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  state: State = {}

  handleInputChange = (customRewardName: string) => {
    this.setState({customRewardName})
  }

  handleButtonClick = () => {
    rewardTracking.rewardsTabAddCustomRewardStart()
    const {customRewardName} = this.state
    history.push(
      {
        pathname: "/reward/create",
        state: {customRewardName}
      },
      this.context
    )
  }

  render() {
    const {formatMessage, intl} = this.props
    const {customRewardName} = this.state

    return (
      <Card>
        <H4>
          <FormattedMessage id="reward.customReward.giveNameTitle" />
        </H4>
        <Input
          name="custom-reward"
          type="custom-reward"
          value={customRewardName}
          placeholder={formatMessage({id: "reward.customReward.input.placeholder"})}
          onChange={this.handleInputChange}
          validation={customRewardNameSchema(intl, MAXIMUM_CUSTOM_REWARD_CHARACTERS)} />
        <Button primary large onClick={this.handleButtonClick}>
          <FormattedMessage id="reward.detail.btnReward.label" />
        </Button>
      </Card>
    )
  }
}

export default injectIntl(Sidebar)
